import { ApiService } from '../api/ApiService';
export class FileStorageService extends ApiService {
    async postFile(input, file, onUploadProgress) {
        const { clientId, entityName, entityId, fileKey, } = input;
        // Create and set the data into FormatData
        const formData = new FormData();
        formData.append('EntityName', entityName);
        formData.append('EntityId', entityId);
        formData.append('FileKey', fileKey);
        formData.append('File', file);
        try {
            const response = await this.post(`/FileStorage/${clientId}`, formData, undefined, onUploadProgress);
            if (response.status === 200)
                return response.data;
            throw new Error('Error uploading the file.');
        }
        catch (error) {
            throw new Error(`Error uploading the file: ${error.message}`);
        }
    }
    async deleteFile(clientId, fileId) {
        try {
            const response = await this.delete(`/FileStorage/${clientId}/${fileId}`);
            if (response.status === 200)
                return response.data;
            throw new Error('Error deleting the file.');
        }
        catch (error) {
            throw new Error(`Error deleting the file: ${error.message}`);
        }
    }
    async getFiles(input) {
        const { clientId, entityName, entityId } = input;
        const inputData = {
            EntityName: entityName,
            EntityId: entityId,
        };
        try {
            const response = await this.get(`/FileStorage/${clientId}`, inputData);
            if (response.status === 200)
                return response.data;
            throw new Error('Error getting list of files.');
        }
        catch (error) {
            throw new Error(`Error getting list of files: ${error.message}`);
        }
    }
}
//# sourceMappingURL=FileStorageService.js.map